import { makeStyles,useTheme } from '@material-ui/core/styles';
import theme from 'theme';

export const useStyles =  makeStyles((theme) => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      margin: '20px 20px 20px 20px'
    }
  },
  column: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '286px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  datePickerWrapper: {
    width: '257px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexWrap: 'wrap',
    }
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexWrap: 'wrap',
    }
  },
  cutOffField: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '120px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  cutOffTypeField: {
    width: '140px',
    marginTop: '17px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: '20px'
    }
  },
  cutOffFieldWrapper: {
    marginRight: '10px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '10px'
    }
  },
  divider: {
    height: '1px',
    marginBottom: '30px',
    backgroundColor: '#e2ebf6'
  },
  checkboxWrapper: {
    margin: '10px 0 24px 0'
  },
  checkboxRoot: {},
  checked: {
    color: '#1D9DC6'
  },
  disabledCheckbox: {
    color: '#BECEDA',
    backgroundColor: '#BECEDA'
  },
  checkboxIcon: {
    color: theme.baseUI.color,
    fontSize: '21px'
  }

}));
